"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var YotpoReview_1 = require("../components/Yotpo/YotpoReview");
// declare window type with additional property within the module
// ref: https://www.totaltypescript.com/how-to-properly-type-window
var targetNode = document.querySelector('.yotpo-review-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(YotpoReview_1.default, null), targetNode);
}
